export function buildRedditShareUrl(url: string, title: string): string {
    return `https://www.reddit.com/submit?url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}`;
}

export function buildTwitterShareUrl(url: string, text: string): string {
    return `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`;
}

export function buildDiscordShareText(text: string, url: string): string {
    return `${text} ${url}`;
}

/** Opens the Discord app (or web client) on the user's direct messages. */
export const DISCORD_DM_URL = 'https://discord.com/channels/@me';

/** Long enough for a "copied" toast to be read before Discord takes focus. */
export const DISCORD_OPEN_DELAY_MS = 2_500;
